import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import AmountContainer from "app/pages/.shared/AmountContainer";
import "./QuotationItem.scss";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";
import AmountSign from "app/pages/.shared/AmountSign/AmountSign";

class QuotationItem extends PureComponent {
	render() {
		const { description, price, isBasePrice } = this.props;

		const sign = price > 0 ? "+" : "-";

		let pricePrefix = isBasePrice ? "" : <AmountSign sign={sign} />;

		return (
			<div
				className={classNames({
					"quotation-item": true,
					"quotation-item--base-price": isBasePrice,
				})}
			>
				<div className="quotation-item__description">{description}</div>
				<div className="quotation-item__price">
					{price === 0 ? (
						<FormattedMessage id="price.detail.offered.label" />
					) : (
						<AmountContainer amount={Math.abs(price)} prefix={pricePrefix} />
					)}
				</div>
			</div>
		);
	}
}

QuotationItem.propTypes = {
	description: PropTypes.string,
	price: PropTypes.number,
	isBasePrice: PropTypes.bool,
};

export default QuotationItem;
